import * as tslib_1 from "tslib";
import { Component, } from "vue-property-decorator";
import { BaseControl } from "@cloudpivot/form/src/renderer/controls";
import { Button, Modal, Table, Form, Row, Col, Input, DatePicker, Popover, Pagination } from "@h3/antd-vue";
import Axios from 'axios';
let collectingKanban = class collectingKanban extends BaseControl {
    constructor() {
        super(...arguments);
        this.visible = false;
        this.form = {
            deviceName: '',
            number: '',
            page: 0,
            size: 10,
            startTime: "",
            endTime: "",
            dateTime: '',
        };
        this.total = '0';
        // pagination:Object={
        // }
        this.slotKey = ['time'];
        this.curPage = 1;
        this.pageSize = 10;
        this.pageSizeOptions = ['10', '20', '50', '100'];
        this.columns = [];
        this.dataList = [
            {
                key: '1',
                deviceName: '篮球',
                number: 32,
                status: '审批中',
            },
            {
                key: '2',
                deviceName: '足球',
                number: 333,
                status: '已归还',
            },
            {
                key: '3',
                deviceName: '羽毛球',
                number: 444,
                status: '闲置',
            },
            {
                key: '3',
                deviceName: '排球',
                number: 555,
                status: '借出',
            },
        ];
        // get allowHalf() {
        //   return this.options.allowHalf
        // }
        // get count() {
        //   return this.options.count
        // }
        // // 那组件配置的属性
        // get options() {
        //   return this.control.options
        // }
        // created() {
        // }
    }
    // this.ctrl 组件的控制器. 组件的value 通过 this.ctrl获取
    openEquipmentKanban() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.form = {
                deviceName: '',
                number: '',
                page: 0,
                size: 10,
                startTime: "",
                endTime: "",
                dateTime: '',
            };
            this.visible = true;
            yield this.getKanban();
        });
    }
    onDateChange(date, dateString) {
        if (dateString.length) {
            this.form.startTime = dateString[0];
            this.form.endTime = dateString[1];
        }
        else {
            this.form.startTime = '';
            this.form.dateTime = '';
        }
    }
    handleOk() {
    }
    handleCancel() {
    }
    showSizeChange(page, size) {
        this.curPage = page;
        this.form.page = page - 1;
        this.form.size = size;
        this.getKanban();
    }
    pageChange(page, size) {
        this.curPage = page;
        this.form.page = page - 1;
        this.form.size = size;
        this.getKanban();
    }
    handleQuery() {
        this.getKanban();
    }
    reset() {
        this.form = {
            deviceName: '',
            number: '',
            page: 0,
            size: 10,
            startTime: "",
            endTime: ""
        };
        this.getKanban();
    }
    getKanban() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.columns = [];
            const res = yield this.boardQuery(this.form);
            console.log(res, 'res-res');
            if (res.errcode === 0) {
                let titleName = {
                    title: '名称',
                    dataIndex: 'deviceName',
                    key: '1',
                    width: '140px',
                    ellipsis: true,
                };
                this.columns.push(titleName);
                let data = res.data;
                this.total = data.total;
                let bodyData = data.bodyData;
                let j = {};
                if (data.titleData && data.titleData.length) {
                    data.titleData.forEach((item, index) => {
                        j[item] = '';
                        let obj = {
                            title: item,
                            dataIndex: item,
                            scopedSlots: { customRender: item },
                            width: '120px'
                        };
                        this.columns.push(obj);
                    });
                }
                console.log(this.columns, '列名');
                let arr = [];
                if (bodyData && bodyData.length) {
                    bodyData.forEach((item, index) => {
                        let obj = {
                            deviceName: item.deviceName,
                            deviceId: item.deviceId,
                        };
                        item.deviceNameData.forEach((j, i) => {
                            j['deviceName'] = item.deviceName;
                            j['deviceId'] = item.deviceId;
                            obj[j.date] = j;
                        });
                        arr.push(obj);
                    });
                }
                this.dataList = arr;
                this.$message.info(res.errmsg);
                console.log(arr, 'obj----333');
            }
            else {
                this.$message.error(res.errmsg);
            }
        });
    }
    //申请器材
    applyingForEquipment(text, record) {
        console.log(text, record, 'text-text-text');
        if (text.equipment_borrowing_status.trim() === '闲置') {
            let url = `/form/detail?startWorkflowCode=apply_for_borrowing&return=%2Fapplication%2FAdministrative%2Fapplication-list%2Fapply_for_borrowing%3FparentId%3D2c2c8085785a1cb00178a6639489489c%26code%3Dapply_for_borrowing%26openMode%26pcUrl%26queryCode%3D%26iframeAction%3Dadd&deviceId=${text.deviceId}&startTime=${record[text.date].date}`;
            window.open(url);
        }
        else {
            let url = `/form/detail?sheetCode=equipment_borrowing_ledg&objectId=${text.legerId}&schemaCode=equipment_borrowing_ledg&isWorkFlow=false&return=%2Fapplication%2FBasicData%2Fapplication-list%2Fequipment_borrowing_ledg%3FparentId%3Dff8080817e6c5b7c017e7191eaa7010e%26code%3Dequipment_borrowing_ledg%26openMode%3D%26pcUrl%3D%26queryCode%3D%26iframeAction%3Ddetail`;
            window.open(url);
        }
    }
    boardQuery(params) {
        return Axios.post('/api/transition/equipment/boardQuery', params);
    }
};
collectingKanban = tslib_1.__decorate([
    Component({
        name: "collectingKanban",
        components: {
            AButton: Button,
            AModal: Modal,
            AInput: Input,
            ATable: Table,
            AForm: Form,
            ADatePicker: DatePicker,
            ARangePicker: DatePicker.RangePicker,
            AFormItem: Form.Item,
            ARow: Row,
            ACol: Col,
            APopover: Popover,
            APagination: Pagination
        }
    })
], collectingKanban);
export default collectingKanban;
